import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CampaignDrawerInfographicService {
    private width = 100;

    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {}

    // Set the shared width for the cards
    setWidth(percentage) {
        // If the percentage is smaller
        if (percentage < this.width) {
            this.width = percentage;
        }

        // Update the css var
        this.document.documentElement.style.setProperty('--infographic-card-width', `${this.width}%`);
    }

    // Get the width as a percentage
    getWidth() {
        // This is really only exposed for testing. The value is read from a css-var
        return `${this.width}%`;
    }
}
